import { useTranslation } from 'react-i18next';
import DocumentoLegal from '../components/DocumentoLegal';
import es from '../legal/privacidad.es';
import en from '../legal/privacidad.en';

export default function Privacidad() {
    const { i18n } = useTranslation();
    return <DocumentoLegal documento={i18n.language?.startsWith('es') ? es : en} />;
}
